<template>
  <div class="layout-footer">
    <div class="content">
      <div class="top">
        <div class="item">
          <div class="title">
            <router-link to="/">首页</router-link>
          </div>
        </div>
        <template v-for="(item, index) in navigationList">
          <div class="item">
            <div class="title">
              <a :href="item.navigationPath" v-if="item.navigationPath">{{ item.navigationName }}</a>
              <span v-else>{{ item.navigationName }}</span>
            </div>
            <template v-for="(menu, key) in item.secNavigationVoList">
              <div class="sub-title">
                <a :href="menu.secNavigationPath">{{ menu.secNavigationName }}</a>
              </div>
            </template>
          </div>
        </template>
        <div class="right">
          <div class="title">
            <img src="@/assets/slices/qrcode.png" alt="" class="qrcode">

          </div>
          <div class="sub-title">关注我们
            <img src="@/assets/slices/icon_subscribe_arrow.png" class="arrow" alt="">
            <img src="@/assets/slices/icon_wechat.png" class="wechat" alt="" @click="showWechatStatus = true">
          </div>
        </div>
      </div>

      <div class="bottom">
        <div class="name">Copyright © 2024 深圳市三维易境科技有限公司</div>
        <div class="no"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024213241号</a></div>
        <div class="link">  </div>
      </div>
    </div>

    <div class="alert" v-show="showWechatStatus">
      <div class="info">
        <div class="close" @click="showWechatStatus = false">
          <img src="@/assets/slices/icon_close.png" alt="">
        </div>
        <div class="title">分享到微信朋友圈</div>
        <div class="wechat">
          <img src="@/assets/slices/main.png" alt="" class="qrcode">
        </div>
        <div class="tips">打开微信，点击底部的“发现”，</div>
        <div class="tips">使用“扫一扫”即可将网页分享至朋友圈。</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState(['navigationList'])
  },
  data() {
    return {
      showWechatStatus: false
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1420px) {
  .layout-footer {

    .content {
      width: 1420px;
    }
  }
}

@media screen and (max-width: 1420px) {
  .layout-footer {

    .content {
      width: 100%;
    }
  }
}

.layout-footer {
  background: url('https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661181626988_bg_bottom%20bar%402x.png') no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: space-around;
  box-sizing: border-box;
  color: #fff;
  position: relative;
  padding: 40px;

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .top {
      display: flex;

      .item {
        flex: 1;
        text-align: left;
      }

      .right {
        width: 169px;
        text-align: right;
        color: #fff;

        .qrcode {
          width: 169px;
          height: 169px;
        }

        .sub-title {
          font-size: 18px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .wechat {
          width: 28px;
          height: 28px;
          cursor: pointer;
        }

        .arrow {
          width: 33px;
          height: 11px
        }
      }

      .title {
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 38px;
      }

      .sub-title {
        font-size: 16px;
        margin-bottom: 20px;
        &:hover{
          color: #EB6100;
        }
      }

    }

    .bottom {
      text-align: center;
      font-size: 16px;
      color: #fff;

      .name {
        margin-bottom: 20px;
      }

      .no {
        margin-bottom: 36px;
      }
    }
  }

  .alert {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 515px;
    height: 517px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 20px 20px 20px 20px;
    z-index: 110;

    .info {
      text-align: center;
      padding: 46px 0 70px;
      position: relative;


      .close {
        width: 40px;
        height: 40px;
        position: absolute;
        right: -63px;
        top: 0;
        cursor: pointer;

        img {
          width: 40px;
          height: 40px;
        }
      }

      .title {
        font-size: 30px;
        line-height: 35px;
        margin-bottom: 29px;
      }

      .wechat {
        display: flex;
        justify-content: center;
      }

      img {
        width: 226px;
        height: 228px;
        background: #FFFFFF;
        border-radius: 13px;
        margin-bottom: 40px;
      }

      .tips {
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 17px;
      }
    }
  }
}
</style>
